import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function startCheckout(lookupKey) {
  const { data } = await axios.post(`${API}/payments/checkout`, {
    lookup_key: lookupKey,
    origin_url: window.location.origin,
  });
  return data;
}

export async function getPaymentStatus(sessionId) {
  const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
  return data;
}

export async function openBillingPortal(email) {
  const { data } = await axios.post(`${API}/payments/portal`, {
    email,
    return_url: `${window.location.origin}/billing`,
  });
  return data; // { portal_url }
}

export async function listInvoices(email) {
  const { data } = await axios.get(`${API}/payments/invoices`, { params: { email } });
  return data; // { invoices: [...] }
}
